module.exports = __webpack_public_path__ + "static/media/ehealth_pro_info_share_p2_2.ebc995a8.png";